import type { ReactNode } from 'react';
import { useLocation } from 'wouter';
import { cn } from '@/lib/utils';

interface ComplianceNavItem {
  href: string;
  label: string;
  exact?: boolean;
}

const NAV_ITEMS: readonly ComplianceNavItem[] = [
  { href: '/compliance', label: '合规总览', exact: true },
  { href: '/compliance/project-statuses', label: '项目合规状态' },
  { href: '/compliance/policy-files', label: '政策文件' },
  { href: '/compliance/promotion-review', label: '宣传审核' },
  { href: '/compliance/sensitive-terms', label: '敏感词库' },
  { href: '/compliance/recheck-queue', label: '复核队列' },
] as const;

export default function ComplianceLayout({ children }: { children: ReactNode }) {
  const [location, navigate] = useLocation();

  return (
    <div className="flex min-h-full gap-6">
      <nav className="w-44 shrink-0">
        <ul className="space-y-1">
          {NAV_ITEMS.map((item) => {
            const isActive = item.exact ? location === item.href : location.startsWith(item.href);
            return (
              <li key={item.href}>
                <button
                  onClick={() => navigate(item.href)}
                  className={cn(
                    'w-full rounded-md px-3 py-2 text-left text-sm font-medium transition-colors',
                    isActive
                      ? 'bg-primary text-primary-foreground'
                      : 'text-gray-700 hover:bg-gray-100',
                  )}
                >
                  {item.label}
                </button>
              </li>
            );
          })}
        </ul>
      </nav>
      <main className="flex-1 overflow-auto">{children}</main>
    </div>
  );
}
